export enum ColumnType {
  Single = "1列表示",
  Multiple = "複数列表示",
}
